import React from "react";
import { Route, Switch } from "react-router";

import usePermission from "provider/PermissionProvider";
import { CONFIGURATION_KEY } from "provider/PermissionProvider/permissions";

import Configurations from "../components/digitalactivation/configuration/view";
import ConfigurationsActivityLogs from "../components/digitalactivation/configuration/ActivityLogs/view";
import Setup from "../components/digitalactivation/configuration/setup";
import Details from "../components/digitalactivation/configuration/details";

import Firmwares from "../components/digitalactivation/firmware/view";
import FirmwaresActivityLogs from "../components/digitalactivation/firmware/ActivityLogs/view";
import FeatureKeys from "../components/digitalactivation/feature-keys/view";
import FeatureKeysActivityLogs from "../components/digitalactivation/feature-keys/ActivityLogs/view";
import Licenses from "../components/digitalactivation/licenses/view";
import LicensesActivityLogs from "../components/digitalactivation/licenses/ActivityLogs/view";
import Vouchers from "../components/digitalactivation/vouchers/view";
import VouchersActivityLogs from "../components/digitalactivation/vouchers/ActivityLogs/view";
import Entitlements from "../components/digitalactivation/voucher-overview/view";
import EntitlementsActivityLogs from "../components/digitalactivation/voucher-overview/ActivityLogs/view";
import VoucherSearch from "../components/digitalactivation/voucher-search/view";
import Users from "../components/digitalactivation/user-management/view";
import UsersActivityLogs from "../components/digitalactivation/user-management/ActivityLogs/view";
import Home from "../components/Home";

import {
  ConfigurationPath,
  ConfigurationActivityLogsPath,
  FirmwaresPath,
  FirmwaresActivityLogsPath,
  FeatureKeysPath,
  FeatureKeysActivityLogsPath,
  LicensesPath,
  LicensesActivityLogsPath,
  VouchersPath,
  VouchersActivityLogsPath,
  VoucherOverviewPath,
  VoucherOverviewActivityLogsPath,
  VoucherSearchPath,
  UserManagementPath,
  UserManagementActivityLogsPath,
} from "./paths";

import { NotFound, Forbidden } from "../components/Errors";
import { PrivateRoute } from "./PrivateRoute";

const Routes = ({ permissions }) => {
  const { permissionContext } = usePermission();
  const { hasAtLeastOneFullPermission } = permissionContext.permissions;

  return (
    <Switch>
      <PrivateRoute
        exact
        path={ConfigurationPath}
        component={Configurations}
        authorized={permissions.includes("Configuration")}
      />
      <PrivateRoute
        exact
        path={ConfigurationActivityLogsPath}
        component={ConfigurationsActivityLogs}
        authorized={permissions.includes("Configuration")}
      />
      <PrivateRoute
        exact
        path="/configuration/setup/:id?"
        component={Setup}
        authorized={
          permissions.includes("Configuration") &&
          hasAtLeastOneFullPermission(CONFIGURATION_KEY)
        }
      />
      <PrivateRoute
        exact
        path="/configuration/details/:id?"
        component={Details}
        authorized={permissions.includes("Configuration")}
      />
      <PrivateRoute
        exact
        path={FirmwaresPath}
        component={Firmwares}
        authorized={permissions.includes("Firmwares")}
      />
      <PrivateRoute
        exact
        path={FirmwaresActivityLogsPath}
        component={FirmwaresActivityLogs}
        authorized={permissions.includes("Firmwares")}
      />
      <PrivateRoute
        exact
        path={FeatureKeysPath}
        component={FeatureKeys}
        authorized={permissions.includes("FeatureKeys")}
      />
      <PrivateRoute
        exact
        path={FeatureKeysActivityLogsPath}
        component={FeatureKeysActivityLogs}
        authorized={permissions.includes("FeatureKeys")}
      />
      <PrivateRoute
        exact
        path={LicensesPath}
        component={Licenses}
        authorized={permissions.includes("Licenses")}
      />
      <PrivateRoute
        exact
        path={LicensesActivityLogsPath}
        component={LicensesActivityLogs}
        authorized={permissions.includes("Licenses")}
      />
      <PrivateRoute
        exact
        path={VouchersPath}
        component={Vouchers}
        authorized={permissions.includes("Vouchers")}
      />
      <PrivateRoute
        exact
        path={VouchersActivityLogsPath}
        component={VouchersActivityLogs}
        authorized={permissions.includes("Vouchers")}
      />
      <PrivateRoute
        exact
        path={VoucherOverviewPath}
        component={Entitlements}
        authorized={permissions.includes("Entitlements")}
      />
      <PrivateRoute
        exact
        path={VoucherOverviewActivityLogsPath}
        component={EntitlementsActivityLogs}
        authorized={permissions.includes("Entitlements")}
      />
      <PrivateRoute
        exact
        path={VoucherSearchPath}
        component={VoucherSearch}
        authorized={permissions.includes("VoucherSearch")}
      />
      <PrivateRoute
        exact
        path={UserManagementPath}
        component={Users}
        authorized={permissions.includes("Users")}
      />
      <PrivateRoute
        exact
        path={UserManagementActivityLogsPath}
        component={UsersActivityLogs}
        authorized={permissions.includes("Users")}
      />

      <Route exact path="/" component={Home} />
      <Route exact path="/forbidden" component={Forbidden} />
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default Routes;
